export default function StepSuccess(props) {
	return (
		<div style={{width:'100%', padding:100}}>
			<h3>Thank you for registering for the SPCA Desexing Programme.</h3>
			<p>Keep an eye out for a verification email to complete your sign up process and for details on what happens next.</p>
			<p>We look forward to working with you!  If you have any questions, please email <a href={"mailto:snipnchip@spca.nz"} target={"_blank"}>snipnchip@spca.nz</a>.</p>
		</div>
	)
}